import { defineMessages } from 'react-intl'

const scope = `procurify.modules.reports.features.listExportTasks.ExportTaskHistoryTable`

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Requested CSV exports',
  },
  columnDatePrepared: {
    id: `${scope}.columnDatePrepared`,
    defaultMessage: 'Date prepared',
  },
  columnFilterOptions: {
    id: `${scope}.columnFilterOptions`,
    defaultMessage: 'Filter options',
  },
  columnStatus: {
    id: `${scope}.columnStatus`,
    defaultMessage: 'Status',
  },
  noFiltersText: {
    id: `${scope}.noFiltersText`,
    defaultMessage: 'N/A',
  },
  statusPreparingText: {
    id: `${scope}.statusPreparingText`,
    defaultMessage: 'Preparing',
  },
  statusFailedText: {
    id: `${scope}.statusFailedText`,
    defaultMessage: 'Failed',
  },
  downloadButtonText: {
    id: `${scope}.downloadButtonText`,
    defaultMessage: 'Download',
  },
  deleteRecordMenuItemText: {
    id: `${scope}.deleteRecordMenuItemText`,
    defaultMessage: 'Delete record',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'No exports requested',
  },
})
